const actionPrefix = (actionType) => `Services/${actionType}`;

export const SET_CONFIG = actionPrefix`SET_CONFIG`;
export const setConfig = (config) => ({
  type: SET_CONFIG,
  payload: config,
});

export const SET_HEADLINE_TITLE = actionPrefix`SET_HEADLINE_TITLE`;
export const setHeadlineTitle = (headlineTitle) => ({
  type: SET_HEADLINE_TITLE,
  payload: headlineTitle,
});

export const SET_HEADLINE_BACK_BUTTON_CONFIG = actionPrefix`SET_HEADLINE_BACK_BUTTON_CONFIG`;
export const setHeadlineBackButtonConfig = (payload) => ({
  type: SET_HEADLINE_BACK_BUTTON_CONFIG,
  payload,
});

export const CLEAR_ROUTE_CONFIG = actionPrefix`CLEAR_ROUTE_CONFIG`;
export const clearRouteConfig = () => ({
  type: CLEAR_ROUTE_CONFIG,
});
